export default __webpack_public_path__ + "static/media/grafema_ummi_14.b987dac3.jpg";